import { Button } from '@cluey/cluey-components';
import { useHistory } from 'react-router';

import { PATHS } from '.';
import { getPossessiveForm } from '../../../hub/SessionMessage/generateSessionDescription';
import type { StudentEntryForm } from './SignUpStudentDetails';

export type StudentsCardProps = {
  students: StudentEntryForm[];
};

const StudentsCard = ({ students }: StudentsCardProps) => {
  const history = useHistory();
  return (
    <div className="rounded-lg border border-grey-3 p-4">
      {students.map((student, index) => (
        <div key={student.firstName}>
          <b className="mr-1">{getPossessiveForm(student.firstName)}</b>
          <span>
            service is aligned to school year {student.schoolYear} ({student.state || student.countryCode})
          </span>
          {index !== students.length - 1 && <div className="my-4 border-b border-grey-3" />}
        </div>
      ))}
      <Button
        appearance="reverse"
        size="xs"
        className="mt-5"
        onClick={() => history.replace(PATHS.STUDENT_DETAILS_PATH)}
      >
        Edit details
      </Button>
    </div>
  );
};

export default StudentsCard;
